import { Alert } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { PortalErrorBoundary } from '~/components/PortalErrorBoundary';
import { AbsencesTab } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab';
import { BasicTab } from '~/scenes/PeopleModule/components/Tabs/BasicTab';
import { ContactTab } from '~/scenes/PeopleModule/components/Tabs/ContactTab';
import { CustomDataTab } from '~/scenes/PeopleModule/components/Tabs/CustomDataTab';
import { CustomPositionTab } from '~/scenes/PeopleModule/components/Tabs/CustomPositionTab';
import { DecisionRegistryTab } from '~/scenes/PeopleModule/components/Tabs/DecisionRegistryTab';
import { DevelopmentTab } from '~/scenes/PeopleModule/components/Tabs/DevelopmentTab';
import { DocumentsTab } from '~/scenes/PeopleModule/components/Tabs/DocumentsTab';
import { EquipmentTab } from '~/scenes/PeopleModule/components/Tabs/EquipmentTab';
import { PerformanceComponent } from '~/scenes/PeopleModule/components/Tabs/Performance';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { EmployeeModuleTabs } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/components/EmployeeModuleTabs';
import { EmployeeModuleTabPath_People } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/PeopleModule/data';
import { useEmployeePeopleModule } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/PeopleModule/useEmployeePeopleModule';

type PropsType = {
  hasFullAccess: boolean;
  modulePath: string;
};

export const EmployeePeopleModule = (props: PropsType) => {
  const { hasFullAccess, modulePath } = props;

  const {
    isLoading,
    tabs,

    enabledTabPaths,
    defaultTab,
    accessMode,
  } = useEmployeePeopleModule({
    hasFullAccess,
    modulePath,
  });

  const { t } = useTranslation();

  const renderTabContent = (tab: string) => {
    if (!enabledTabPaths.map((p) => p.toString()).includes(tab)) {
      return <Alert severity={'error'}>{t('laNoAuthorization')}</Alert>;
    }

    switch (tab) {
      case EmployeeModuleTabPath_People.Basic:
        return <BasicTab accessMode={accessMode} />;
      case EmployeeModuleTabPath_People.CustomData:
        return <CustomDataTab />;
      case EmployeeModuleTabPath_People.DecisionRegistry:
        return <DecisionRegistryTab />;
      case EmployeeModuleTabPath_People.JobDescription:
        return <CustomPositionTab />;
      case EmployeeModuleTabPath_People.Contact:
        return <ContactTab />;
      case EmployeeModuleTabPath_People.Equipment:
        return <EquipmentTab />;
      case EmployeeModuleTabPath_People.Documents:
        return <DocumentsTab />;
      case EmployeeModuleTabPath_People.Absences:
        return <AbsencesTab accessMode={accessMode} />;
      case EmployeeModuleTabPath_People.Performance:
        return <PerformanceComponent />;
      case EmployeeModuleTabPath_People.Development:
        return <DevelopmentTab />;
      default:
        return <></>;
    }
  };

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <EmployeeModuleTabs
      defaultTab={defaultTab}
      enabledTabPaths={enabledTabPaths}
      tabs={tabs}
      render={(tab) => (
        <PortalErrorBoundary>{renderTabContent(tab)}</PortalErrorBoundary>
      )}
    />
  );
};
